interface AddressType {
  postalCode?: string
  region?: string
  city?: string
  cityDistrict?: string
  settlement?: string
  street?: string
  flat?: string
  entrance?: string
  floor?: string
  doorphone?: string
}

export function makeAddress(address: AddressType): string {
  const fields = [
    'postalCode',
    'region',
    'city',
    'cityDistrict',
    'settlement',
    'street',
    'flat',
    'entrance',
    'floor',
    'doorphone',
  ] as const

  return fields
    .reduce<string[]>((acc, key) => {
      const value = address[key]

      if (!value) {
        return acc
      }

      switch (key) {
        case 'flat':
          acc.push(`кв. ${value}`)
          break

        case 'entrance':
          acc.push(`под. ${value}`)
          break

        case 'floor':
          acc.push(`этаж ${value}`)
          break

        case 'doorphone':
          acc.push(`домофон ${value}`)
          break

        default:
          acc.push(value)
      }

      return acc
    }, [])
    .join(', ')
}
